import { createPinia } from 'pinia'
import { markRaw } from 'vue';
import {ApiClient} from "@/scripts/api";
import router from '../router';
const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3015/ccp_api_v1'
const API_URL_V2 = process.env.VUE_APP_API_URL_V2 || 'http://localhost:3015/ccp_api_v2'

function attachApi() {
    return { apiClient:  new ApiClient(API_URL) }
}
function attachApi2() {
    return { apiClientV2:  new ApiClient(API_URL_V2) }
}
export const pinia = createPinia()
pinia.use(attachApi)
pinia.use(attachApi2)
pinia.use(({ store }) => {
    store.$router = markRaw(router)
});